import { DecisionForm } from "./form";

export function DecisionCreate() {
  return <DecisionForm action="create" />;
}

export default DecisionCreate;
